import React from 'react';

interface Props {
    children: React.ReactNode;
}

const Page: React.FunctionComponent<Props> = (props: Props) => <div className='px-3'>{props.children}</div>;

export default Page;
